import React, { Fragment, useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import { handleTitle } from '#app/actions/interface';
import { Chart } from './../../styles';
import { useChart } from './hooks/useChart';
import LoaderContainer from '#app/components/LoaderContainer/LoaderContainer';
import { useAmCharts } from '#app/hooks/useAmCharts';

const SalaryPlanChart = (props) => {
  const {
    chartId,
    items,
    allowEdit,
    type,
    incomeField,
    retiredAge,
    deadAge,
    tutorial,
    incomeUpdateValue,
    outcomeUpdateValue,
    childRef,
  } = props;
  const dispatch = useAppDispatch();
  const client = useAppSelector((s) => s.interfaceComponents.client);
  const handleTitleFn = useCallback((title) => dispatch(handleTitle(title)), [dispatch]);

  const chartProps = {
    items,
    allowEdit,
    type,
    incomeField,
    retiredAge,
    deadAge,
    tutorial,
    incomeUpdateValue,
    outcomeUpdateValue,
  };

  const { loading: chartsLoading } = useAmCharts();
  const { initializeChart, updateChart } = useChart(chartId, client, chartProps);

  useEffect(() => {
    handleTitleFn('Формирование прогноза по доходам/расходам');
  }, [handleTitleFn]);

  useEffect(() => {
    if (childRef) {
      childRef({
        updateChart: (clientData, allowEditData) => {
          updateChart();
        },
      });
    }
  }, [childRef, updateChart]);

  let filteredItems = [];

  if (items && typeof items.filter === 'function') {
    filteredItems = items?.filter((item) => item.plan_income !== 0);
  }

  const hasItems = filteredItems.length > 0;

  return (
    <Fragment>
      <LoaderContainer loader={chartsLoading} height="490px" />
      <Chart
        id={chartId}
        style={{
          display: !chartsLoading && hasItems ? 'block' : 'none',
          height: '490px',
          flexBasis: '100%',
          fontSize: '18px',
        }}
        ref={initializeChart}
      />
      <img
        src={require('#app/assets/frames/plan.svg')}
        alt=""
        style={{
          display: !chartsLoading && !hasItems ? 'block' : 'none',
          marginTop: '12px',
          width: '100%',
          height: '490px',
          boxSizing: 'border-box',
          padding: '0 15px',
        }}
      />
    </Fragment>
  );
};

export default SalaryPlanChart;
